<template>
  <span class="notification-badge">{{ notificationNumber }}</span>
</template>

<script>
export default {
  props: {
    notificationNumber: {
      type: Number,
      required: true
    }
  }
};
</script>
<style lang="scss">
.notification-badge {
  background-color: #c03;
  color: white;
  align-items: center;
  border-radius: 1.25rem;
  font-size: 0.75rem;
  text-align: center;
  line-height: 1.25rem;
  min-width: 1.25rem;
  display: inline-block;
}
</style>
